<template>
  <div>
    <b-dropdown
      id="dropdown-checkboxes"
      text="Column Settings"
      variant="outline-primary"
      menu-class="dropdown-menu-sm dropdown-menu-end"
    >
      <div class="py-1 px-4">
        <div class="my-2">
          <form @submit.prevent>
            <div class="input-group mb-3">
              <b-form-input
                v-model="filterKeyword"
                placeholder="Search Column Name"
              />
              <b-button
                v-show="filterKeyword"
                variant="outline-secondary"
                type="button"
                class="px-3 btn-search-append"
                @click="filterKeyword = null"
              >
                <i class="fa fa-times" />
              </b-button>
            </div>
          </form>
        </div>
      </div>
      <b-dropdown-item
        v-for="(field, index) in filteredFields"
        :key="index"
        @click.native.capture.stop="toggleCheckbox(field.key)"
      >
        <b-form-group>
          <div
            class="d-flex mb-2 mr-sm-2 mb-sm-0"
          >
            <input
              :id="index"
              v-model="selectedTableFields"
              type="checkbox"
              :value="field.key"
            >
            <span
              :for="index"
              class="ms-1 my-auto"
            >
              {{ field.label }}
            </span>
          </div>
        </b-form-group>
      </b-dropdown-item>
      <hr>
      <div class="d-flex mx-4 mb-2">
        <span class="fw-bold me-auto my-auto">
          Precision Input
        </span>
        <div class="ms-auto">
          <label
            v-for="(option, index) in [1, 2, 3, 4]"
            :key="index"
            class="my-auto ms-2"
          >
            <input
              v-model="precisionInput"
              :value="option"
              type="radio"
              checked
            >
            <span>{{ option }}</span>
          </label>
        </div>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import { ColumnService, PrecisionService } from '../services/local-storage';

export default {
  props: {
    tableFields: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      precisionInput: 1,
      selectedTableFields: [],
      filterKeyword: null,
    };
  },
  computed: {
    filteredFields() {
      if (this.filterKeyword) {
        return this.tableFields.filter((item) => item.label.toLowerCase().includes(this.filterKeyword.toLowerCase()));
      } return this.tableFields;
    },
  },
  watch: {
    selectedTableFields: {
      immediate: false,
      handler() {
        ColumnService.set({ data: this.selectedTableFields });
        this.$emit('filterChange', this.selectedTableFields);
      },
    },
    precisionInput: {
      immediate: false,
      handler(value) {
        PrecisionService.set(value);
        this.$emit('precisionChange', value);
      },
    },
  },
  mounted() {
    this.populateColumn();
    this.precisionInput = PrecisionService.get();
  },
  methods: {
    toggleCheckbox(key) {
      const isSelected = this.selectedTableFields.includes(key);

      if (isSelected) {
        this.selectedTableFields = this.selectedTableFields.filter(
          (field) => field !== key,
        );
      } else {
        this.selectedTableFields.push(key);
      }
    },
    populateColumn() {
      const storedColumn = ColumnService.get();
      if (storedColumn.data) {
        this.selectedTableFields = storedColumn.data;
      } else {
        this.selectedTableFields = this.tableFields.map((field) => field.key);
      }
    },
  },
};

</script>
<style scoped>
label {
  display: inline-block;
  position: relative;
}

label input[type="radio"] {
  display: none;
}

label span {
  text-align: center;
  display: inline-block;
  min-width: 30px;
  padding: 4px 8px;
  border: 1px solid #ccc;
  cursor: pointer;
}

label input[type="radio"]:checked + span {
  font-weight: 1000;
  border-color: #556ee6;
}
::v-deep .dropdown-menu {
  max-height: 75vh;
  min-width: 350px;
  overflow-y: auto;
}
</style>
